<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="title">
        <span slot="label">
          <a-tooltip>
            标题<template slot="title">标题</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.title" :maxLength="100" :placeholder="$t('请输入')+'标题'" :disabled="formType===2" >
          <locale-field-button
            slot="suffix"
            v-model="form.localeFieldMap['title']"
            :disabled="!form.title"
            input-type="input"
            table-name="system_pages"
            table-field="title"
            :field-value="form.title"
          />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="description">
        <span slot="label">
          <a-tooltip>
            说明<template slot="title">说明</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.description" :maxLength="255" :placeholder="$t('请输入')+'说明'" />
      </a-form-model-item>
      <a-form-model-item prop="content">
        <span slot="label">
          <a-tooltip>
            内容<template slot="title">内容</template>
          </a-tooltip>
        </span>
        <div class="editor-i18n-wrapper">
          <editor v-model="form.content" :placeholder="$t('请输入')"/>
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button editor-i18n-btn"
            v-model="form.localeFieldMap['content']"
            :disabled="!form.content"
            input-type="editor"
            table-name="system_pages"
            table-field="content"
            :field-value="form.content"
          />
        </div>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMsgSystemPages, addMsgSystemPages, updateMsgSystemPages } from '@/api/msg/msgSystemPages'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

import Editor from '@/components/Editor'
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    CustomDictTag,
    Editor
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        title: null,

        description: null,

        content: null,

        status: 0,
        localeFieldMap: {},

        sort: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: '标题' + this.$t('不能为空'), trigger: 'blur' }
        ],
        description: [
          { required: true, message: '说明' + this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态：0=关闭 1=启用' + this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序，值越小越靠前' + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        description: null,
        content: null,
        status: 1,
        localeFieldMap: {},
        sort: 1
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMsgSystemPages({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateMsgSystemPages(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addMsgSystemPages(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.editor-i18n-wrapper {
  position: relative;
}
/* deep selector to reach into child component root */
.editor-i18n-wrapper /deep/ .ant-input-suffix-button.editor-i18n-btn {
  position: absolute !important;
  bottom: 1px;
  right: 8px !important;
  z-index: 3000;
}
</style>